import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, BellOff, Loader2, AlertTriangle } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { pushSupported, isStandalone, currentSubscription, enablePush, disablePush } from "@/lib/push";

export function PushNotificationsCard() {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [ready, setReady] = useState(false);
  const supported = pushSupported();
  const iosNeedsInstall = /iphone|ipad|ipod/i.test(navigator.userAgent) && !isStandalone();

  useEffect(() => { (async () => {
    try { setOn(!!(await currentSubscription())); } catch (_) {} finally { setReady(true); }
  })(); }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      if (on) { await disablePush(); setOn(false); toast.success("Notifiche disattivate."); }
      else {
        await enablePush(); setOn(true);
        try { await api.post("/push/test"); } catch (_) {}
        toast.success("Notifiche attivate. Ti invieremo gli avvisi dell'agenda.");
      }
    } catch (e) { toast.error(e.message || apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card-immo p-5" data-testid="push-card">
      <div className="flex items-center gap-2.5 mb-3">
        <div className="w-9 h-9 rounded-xl bg-[#FC82ED]/15 border border-[#FC82ED]/30 flex items-center justify-center text-[#FC82ED]"><BellRing size={18} /></div>
        <h3 className="font-display font-bold text-base">Notifiche push sul telefono</h3>
      </div>
      <p className="text-sm text-[var(--muted)] mb-4">Ricevi un avviso quando ti viene fissato un appuntamento, quando viene spostato o annullato, e un promemoria poco prima. Nessun dato sensibile del cliente è incluso nella notifica.</p>
      {!supported && <div className="flex items-start gap-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3"><AlertTriangle size={16} className="shrink-0 mt-0.5" /> Questo dispositivo/browser non supporta le notifiche.</div>}
      {supported && iosNeedsInstall && (
        <div className="flex items-start gap-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3 mb-3" data-testid="push-ios-hint">
          <AlertTriangle size={16} className="shrink-0 mt-0.5" /> Su iPhone, installa prima l'app sulla schermata Home (sezione qui sopra), poi apri Immobilart da lì e attiva le notifiche.
        </div>
      )}
      {supported && (
        <button onClick={toggle} disabled={busy || !ready} data-testid="push-toggle-btn"
                className={`w-full py-3 rounded-lg font-semibold text-sm transition-colors flex items-center justify-center gap-2 disabled:opacity-60 ${on ? "bg-red-50 border border-red-200 text-red-600 hover:bg-red-100" : "bg-[#FC82ED] text-black hover:bg-[#e06dd2]"}`}>
          {busy ? <Loader2 size={16} className="animate-spin" /> : (on ? <BellOff size={16} /> : <BellRing size={16} />)}
          {on ? "Disattiva notifiche" : "Attiva notifiche"}
        </button>
      )}
    </div>
  );
}
